import type { QuoteSensor } from '../types';

/** Raw sensor shape from GET /v4/accounts/:id/sensors (the V4/PG picker source). */
export interface V4AccountSensor {
  id: string;
  mongoSensorId: string;
  name: string;
  status: number;
  customId: string | null;
  streamName: string | null;
  usergroupName?: string | null;
  sensorgroups?: Array<{ id: string; name: string }> | null;
  calibrationCertNumber?: string | null;
  calibrationDue?: string | null;
  mongoStreamId?: string | null;
  mongoCalibrationId?: string | null;
  site: { id: string; name: string } | null;
  location: { id: string; name: string } | null;
  invoices: string[] | null;
  quotes: string[] | null;
  invoiceAssociations?: QuoteSensor['invoiceAssociations'];
  quoteAssociations?: QuoteSensor['quoteAssociations'];
}

/**
 * Map a V4 account-sensor (the PG picker payload) to the QuoteSensor shape the quote sensor
 * list renders. The V4 endpoint already returns calibration (cert # + due date) and the user
 * group name — the previous mapping dropped both, so migrated (PG-account) customers saw blank
 * calibration and no user group in the quote's sensor picker. (Sensor *groups* — plural — are
 * not in this payload yet; that part needs the rest_server endpoint extended.)
 */
export function mapV4AccountSensor(s: V4AccountSensor): QuoteSensor {
  return {
    _id: s.mongoSensorId,
    customid: s.customId || undefined,
    name: s.name,
    status: s.status,
    location: s.location ? { _id: s.location.id, name: s.location.name } : undefined,
    stream: s.streamName
      ? {
          _id: s.mongoStreamId || '',
          name: s.streamName,
          calibration: s.calibrationCertNumber
            ? {
                cert_number: s.calibrationCertNumber,
                due: s.calibrationDue || undefined,
                date: s.calibrationDue || undefined,
                calibrationrecord: s.mongoCalibrationId || undefined,
              }
            : undefined,
        }
      : undefined,
    usergroup: s.usergroupName || undefined,
    sensorgroups: s.sensorgroups ?? [],
    invoices: s.invoices || [],
    quotes: s.quotes || [],
    invoiceAssociations: s.invoiceAssociations,
    quoteAssociations: s.quoteAssociations,
  };
}
